import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "../../components/Motion";
import Seo from "../../components/Seo";
import Marquee from "../../components/Marquee";
import MapBlock from "../../components/MapBlock";
import Hero from "./Hero";
import Bento from "./Bento";
import AboutAdBlue from "./AboutAdBlue";
import FeaturedProducts from "./FeaturedProducts";
import ShopsSection from "./ShopsSection";
import QuickEnquiry from "./QuickEnquiry";
import DispensingEquipment from "../../components/DispensingEquipment";
import { SITE } from "../../lib/site";

const STEPS = [
  ["Enquire", "Call, WhatsApp or send a form with your product and quantity."],
  ["Get a quote", "We share pricing and availability for your requirement."],
  ["Confirm", "Finalise the order, pack size and delivery location."],
  ["Dispatch", "Your order is dispatched from Haldia."],
];

const Process = () => (
  <section data-testid="home-process" className="relative overflow-hidden bg-navy py-24 md:py-32 text-white grain">
    <div className="absolute inset-0 grid-lines" />
    <div className="relative mx-auto max-w-7xl px-5 lg:px-8">
      <Reveal>
        <p className="eyebrow text-brand">How ordering works</p>
        <h2 className="mt-4 max-w-3xl font-display text-5xl md:text-6xl font-extrabold uppercase leading-[0.92]">Four steps from enquiry to dispatch.</h2>
      </Reveal>
      <div className="mt-16 grid gap-px overflow-hidden rounded-[26px] bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map(([t, d], i) => (
          <Reveal key={t} delay={i * 0.1} className="h-full">
            <div className="group h-full bg-navy p-8 transition-colors duration-500 hover:bg-navy-light">
              <span className="font-display text-7xl font-black text-outline transition-colors duration-500 group-hover:text-brand">0{i + 1}</span>
              <h3 className="mt-6 font-display text-3xl font-bold uppercase">{t}</h3>
              <p className="mt-2 text-slate-300">{d}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

const CtaLocation = () => (
  <section data-testid="home-location" className="bg-white py-24 md:py-32">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 lg:grid-cols-12 lg:px-8">
      <Reveal className="lg:col-span-5 flex flex-col justify-center">
        <p className="eyebrow text-brand">Find us</p>
        <h2 className="mt-4 font-display text-5xl md:text-6xl font-extrabold uppercase leading-[0.92] text-navy">Rooted in Haldia. Ready for India.</h2>
        <p className="mt-6 text-slate-600">{SITE.location}</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/bulk-orders" data-testid="cta-bulk-button" className="group inline-flex items-center gap-2 rounded-full bg-brand px-7 py-4 font-semibold text-white transition-[background-color,transform] hover:bg-brand-dark hover:-translate-y-0.5">
            Request bulk quote <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
          </Link>
          <Link to="/dealer-franchise" data-testid="cta-dealer-button" className="inline-flex items-center gap-2 rounded-full border border-navy/15 px-7 py-4 font-semibold text-navy transition-colors hover:border-navy">
            Become a dealer
          </Link>
        </div>
      </Reveal>
      <Reveal delay={0.1} className="lg:col-span-7">
        <MapBlock />
      </Reveal>
    </div>
  </section>
);

export default function Home() {
  return (
    <>
      <Seo title="AdBlue & Lubricating Oil Supplier in Haldia, West Bengal" description="MHM SUPER ADBLUE supplies AdBlue (DEF) and lubricating oils — Tata, Gulf, Eicher, BharatBenz — for trucks and transport businesses. Bulk orders and dealership enquiries welcome." />
      <Hero />
      <Marquee />
      <AboutAdBlue />
      <Bento />
      <FeaturedProducts />
      <DispensingEquipment />
      <QuickEnquiry />
      <ShopsSection />
      <Process />
      <CtaLocation />
    </>
  );
}
